import { useState } from 'react';
import { TCustomTableProps } from './CustomTable.type';
import './CustomTableFin.scss';
import { FINANCIAL_INFO } from '../../../Constants/Constants';

const CustomTableFin = (props: TCustomTableProps) => {
  const {
    id,
    data,
    tableLabel,
    tableLabelActionBtnVisibility = false,
    additionalClass,
    tableColumnTitle,
    modalView,
    callback,
    rowdata,
  } = props;

  const [showTableContent, setshowTableContent] = useState(false);

  const getMonthYear = (date: any) => {
    if (isNaN(date)) {
      const dateObj = new Date(date);
      const day = dateObj.toLocaleString('default', { day: 'numeric' });
      const month = dateObj.toLocaleString('default', { month: 'long' });
      const year = dateObj.getFullYear();
      return `${month} ${day}, ${year}`;
    } else {
      const dateString = date.toString();
      if (dateString.length === 4) return dateString;
      const dateObj = new Date(dateString.substr(0, 4), dateString.substr(4, 2) - 1);
      const month = dateObj.toLocaleString('default', { month: 'long' });
      const year = dateObj.getFullYear();
      return `${month} ${year}`;
    }
  };

  return (
    <div className={`CustomTableFin ${additionalClass}`}>
      {tableLabel && tableLabel !== '' && (
        <div className="Table_Action">
          {!modalView && <span>{tableLabel}</span>}
          {tableLabelActionBtnVisibility && (
            <img
              src={`/oo/assets/icon/${showTableContent ? 'minus-icon' : 'plus'}.svg`}
              className="Table_Action_Icon"
              alt="Action"
              onClick={() => {
                setshowTableContent(!showTableContent);
              }}
            />
          )}
        </div>
      )}
      {((tableLabelActionBtnVisibility && showTableContent) || !tableLabelActionBtnVisibility) && (
        <>
          {data?.length ? (
            <div className={`FinancialInfo_List ${id === FINANCIAL_INFO.TAX_FORMS ? 'Gradient_Background' : ''}`}>
              <div className="Table_Body">
                {data?.map((item: any, index: number) => {
                  return id === FINANCIAL_INFO.TAX_FORMS ? (
                    <div className="Table_Row" key={index}>
                      <span>{item?.year}</span>
                      {item?.data?.map((taxItem: any) => {
                        return (
                          <>
                            <div className="Clickable_Row" key={taxItem.formItem.name}>
                              <div
                                className="Clickable_Item"
                                onClick={() => {
                                  callback(id, item?.year, taxItem.formItem);
                                }}
                              >
                                <img
                                  src="/oo/assets/icon/docunment-tax.svg"
                                  alt="Tax"
                                  className="Document_Icon"
                                />{' '}
                                <span className="Tax_Item_Name">{taxItem.formItem.name}</span>
                              </div>
                            </div>
                          </>
                        );
                      })}
                    </div>
                  ) : (
                    <div
                      className="Table_Row"
                      key={index}
                      onClick={() => {
                        callback(id, item);
                      }}
                    >
                      <span>
                        {item?.commodityDesc ||
                          item?.type ||
                          (item?.date && getMonthYear(item?.date))}
                      </span>
                      <span>{item?.packagingType || item?.value}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="No_Data">
              <img src="/oo/assets/icon/document-none.svg" alt="No Data" />
              <p>No {rowdata} data available</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default CustomTableFin;
